module.exports = __webpack_public_path__ + "media/img/illustrations/cross@1.5x-58fe9b2ecc86adbea0ba84451b7c3dae.svg";